import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faPhoneAlt , faEnvelope, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons'



import '../../css/style.css'

library.add(fab)


const Footer = ({ siteTitle }) => (
  
    <div className="footer-settings">
        <div className="container">

            <div>

                <div className="footer-box footer-address">
                    <a href="https://g.page/FixStars?share" target="_blank">
                        <FontAwesomeIcon icon = {faMapMarkedAlt} />
                        <span className="footer-address-desktop">&nbsp;&nbsp;7 Princeton St. KENMORE 4069</span>
                        <span className="footer-address-mobile">&nbsp;&nbsp;7 Princeton St.</span>
                    </a>
                </div>

                <div className="footer-box footer-mobile">
                    <a href="tel:0401704858">
                        <FontAwesomeIcon icon = {faPhoneAlt} />
                        <span>&nbsp;&nbsp;0401 704 858</span>
                    </a>
                    
                </div>

                <div className="footer-box footer-sns">
                    <span >
                        <a href="https://www.instagram.com/fixstars_/" target="_blank">
                            <FontAwesomeIcon icon = {["fab","instagram"]} size="lg"/>
                        </a>
                        &emsp; 
                        <a href="https://www.facebook.com/fixstarsbrisbane" target="_blank">
                            <FontAwesomeIcon icon = {["fab","facebook-square"]} size="lg"/>
                        </a>
                    </span>
                </div>

            </div>

            
        </div>
        
    </div>
)

export default Footer